module.exports = __webpack_public_path__ + "img/status_yxz_icon.28c02963.png";